export default "__VITE_ASSET__SyZbN1ae__"